import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api`
  : (import.meta.env.MODE === 'production' ? '/api' : '/api')

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
  withCredentials: true
})

let csrfToken = null

const fetchCsrfToken = async () => {
  try {
    const response = await axios.get('/api/csrf-token', { withCredentials: true })
    csrfToken = response.data.csrfToken
    return csrfToken
  } catch (err) {
    console.warn('CSRF token fetch failed:', err)
  }
}

fetchCsrfToken()

api.interceptors.request.use(
  async (config) => {
    const method = config.method?.toUpperCase()
    if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
      if (!csrfToken) {
        await fetchCsrfToken()
      }
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (
      error.response?.status === 403 &&
      error.response?.data?.error === 'CSRF validation failed' &&
      !originalRequest._csrfRetry
    ) {
      originalRequest._csrfRetry = true
      try {
        await fetchCsrfToken()
        originalRequest.headers['X-CSRF-Token'] = csrfToken
        return api.request(originalRequest)
      } catch {
        return Promise.reject(error)
      }
    }

    return Promise.reject(error)
  }
)

export const refreshCsrfToken = fetchCsrfToken

export default api
